import { createComponentHealth } from '@shared/components/ComponentHealth';

export const [wrapWithCreateBabyRegistryEventHealthProvider, useCreateBabyRegistryEventHealth] = createComponentHealth('CreateEventFlow | Create Baby Registry Event');
